
import { Placement } from '@post-office/placements-frontend/ct-changeboarding-message';
export default Placement;
